import { Component, inject } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ToastModule } from 'primeng/toast';
import { filter } from 'rxjs';
import { MessageService } from 'primeng/api';
import { HeaderService } from './Common/Services/header.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ToastModule, ConfirmDialogModule],
  templateUrl: './app.html',
  styleUrl: './app.css',
})
export class App {
  private messageService = inject(MessageService);
  private router = inject(Router);
  private activatedRoute = inject(ActivatedRoute);
  private headerService = inject(HeaderService);

  ngOnInit() {
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((nav) => {
      if(!nav.url.includes('dashboard')){
        this.messageService.clear();
      }
      let route = this.activatedRoute.firstChild;
      while (route?.firstChild) route = route.firstChild;

      const staticTitle = route?.snapshot.data['headerTitle'];
      const staticSubTitle = route?.snapshot.data['headerSubTitle'];

      // Reset on every navigation, then apply static title and subtitle if it exists
      this.headerService.title.set(null);
      this.headerService.subTitle.set(null);
      if (staticTitle) {
        this.headerService.title.set(staticTitle);
      }
      if (staticSubTitle) {
        this.headerService.subTitle.set(staticSubTitle);
      }
    });
  }
}
